import "../styles/header.css";
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
function NavBar(props) {
  function toggle() {
    document.getElementsByClassName("links")[0].classList.toggle("active");
    document.getElementsByClassName("link")[0].classList.toggle("active");
    document.getElementsByClassName("link")[1].classList.toggle("active");
    document.getElementsByClassName("link")[2].classList.toggle("active");
    document.getElementsByClassName("link")[4].classList.toggle("active");
    document.getElementsByClassName("link")[3].classList.toggle("active");
    document.getElementsByClassName("ground")[0].classList.toggle("active");
  }

  const [windowDimenion, detectHW] = useState({
    winWidth: window.innerWidth,
    winHeight: window.innerHeight,
  });

  const detectSize = () => {
    detectHW({
      winWidth: window.innerWidth,
      winHeight: window.innerHeight,
    });
  };

  useEffect(() => {
 
    window.addEventListener("resize", detectSize);

    return () => {
      window.removeEventListener("resize", detectSize);
    };
  }, [windowDimenion]);
  return (
    <div>
      <nav id="navBar">
        <div className="completeLogo">
          <img src="/images/blueLogo.jpg" className="logotext" alt="" />
          <div className="nameLogo">
            Maker
            <br />
             Skills 
          </div>
        </div>

        <div className="ground">
          <div className="links">
            <Link
              to="/"
              className="link"
              style={{
                color: props.type === "overview" ? "#F1680D " : "white",
                fontWeight: props.type === "overview" ? "bold" : "300",

                textDecoration:
                  props.type === "overview" ? "underline" : "none",
              }}
            >
              Home
            </Link>
            <Link
              to="/learn"
              className="link"
              style={{
                color: props.type === "learn" ? "#F1680D " : "white",
                fontWeight: props.type === "learn" ? "bold" : "300",

                textDecoration: props.type === "learn" ? "underline" : "none",
              }}
            >
              Courses
            </Link>
            <Link
              to="/services"
              className="link"
              style={{
                color: props.type === "service" ? "#F1680D " : "white",
                fontWeight: props.type === "service" ? "bold" : "300",

                textDecoration: props.type === "service" ? "underline" : "none",
              }}
            >
              Fablab
            </Link>
            <Link
              to="/shop"
              className="link"
              style={{
                color: props.type === "shop" ? "#F1680D " : "white",
                fontWeight: props.type === "shop" ? "bold" : "300",
                textDecoration: props.type === "shop" ? "underline" : "none",
              }}
            >
              Shop
            </Link>
            <Link
              to="/contact-us"
              className="link"
              style={{
                color: props.type === "contact" ? "#F1680D " : "white",
                fontWeight: props.type === "contact" ? "bold" : "300",

                textDecoration: props.type === "contact" ? "underline" : "none",
              }}
            >
              Contact Us
            </Link>      
          </div>
        </div>
      </nav>
      <img id="menuIcon" onClick={toggle} src="../images/menu.png" alt="" />
    </div>
  );
}
export default NavBar;
